import { Box, Button, Checkbox, FormControlLabel, FormGroup, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Colors } from '~/libs/mui/theme'

interface WithdrawalSelectReasonProps {
  defaultSelectedReason: string[]
  reasons: {
    [key in string]: string
  }
  isValidated: boolean
  onChangeSelectedReason: (e: React.ChangeEvent<HTMLInputElement>) => void
  onClickCancel: () => void
  onClickProceed: () => void
}

export function WithdrawalSelectReason({
  defaultSelectedReason,
  reasons,
  isValidated,
  onClickCancel,
  onClickProceed,
  onChangeSelectedReason,
}: WithdrawalSelectReasonProps): JSX.Element {
  const reasonsKeys = Object.keys(reasons)
  const { t } = useTranslation()

  return (
    <Box>
      <Typography fontWeight={500}>{t('indicate_reason_for_cancellation')}</Typography>
      <FormGroup
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: { xs: 1, sm: 2 },
          mt: { xs: 1, sm: 1.5 },
        }}
        onChange={onChangeSelectedReason}
      >
        {reasonsKeys.map((reasonKey, idx) => (
          <FormControlLabel
            key={'reason' + idx}
            checked={defaultSelectedReason.includes(reasonKey)}
            control={<Checkbox />}
            label={[reasons[reasonKey]]}
            value={reasonKey}
            sx={{ backgroundColor: Colors.color1A1A18, borderRadius: 1, margin: 0 }}
          />
        ))}
      </FormGroup>
      <Box display='flex' flexDirection='column' mt={{ xs: 6, sm: 7 }} gap={{ xs: 1, sm: 2 }}>
        <Button
          sx={{
            background: Colors.color2F2F31,
            color: Colors.red,
          }}
          onClick={onClickProceed}
          disabled={!isValidated}
        >
          {t('proceed_unsubscribe')}
        </Button>
        <Button
          sx={{ backgroundColor: Colors.color1A1A18, color: Colors.color7E7E80 }}
          onClick={onClickCancel}
        >
          {t('cancel_withdrawal')}
        </Button>
      </Box>
    </Box>
  )
}
